import { render, staticRenderFns } from "./RinvPT_Details.vue?vue&type=template&id=5e47c4b4"
import script from "./RinvPT_Details.vue?vue&type=script&lang=js"
export * from "./RinvPT_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports